import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './redux/reducer';
import rootSaga from './redux/saga';

const create = (context = {}) => {
  const sagaMiddleware = createSagaMiddleware({
    context: {
      ...context,
    },
  });
  const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));
  sagaMiddleware.run(rootSaga);
  return store;
};

export default create;
